/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var par = require("par");
var window = require("global");
var extend = require("xtend");

var IS_LEGACY = !!(window.InfoGetter && window.InfoGetter.getBleSettings);
var MAX_BRACELETS = 8;

module.exports = new Model({
	name: "braceletfinder",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_bracelets: null,

	tryConnectedResponse: tryConnectedResponse,
	tryFoundResponse: tryFoundResponse,
	respondIfConnected: respondIfConnected,
	respondIfFound: respondIfFound,
	setFinding: setFinding,
});

function init() {
	this._bracelets = {};
	this.setFinding([]);
}

function uninit() {
	this._bracelets = null;
}

function setFinding(list) {
	this.push(list);
}

function triggers() {
	return {
		"find": find,
		"find:finish": finishFind
	};
}

function listeners() {
	return {
		"bluetooth:scanned": tryFoundResponse,
		"bluetooth:failed": handle_connection_failed,
		"bracelets:updated": handleBraceletsUpdated,
		"machineevents:find": find,
		"machineevents:find:finish": finishFind,
		"machineevents:take": handle_take,
	};
}

function handleBraceletsUpdated(bracelets) {
	this._bracelets = bracelets;
	this.tryConnectedResponse();
}

function tryConnectedResponse() {
	var finding = this.data;
	if (!finding.length) return;
	var changed = finding.filter(respondIfConnected, this);

	if (finding.length === changed.length) return;

	if (!changed.length)
		this.emit("bluetoothscanner:trigger:stop");

	this.setFinding(changed);
}

function respondIfConnected(finding) {
	var bracelet = finding.bracelet;
	var machine = finding.from;

	if (this._bracelets[bracelet]) {
		this.emit("machineevents:trigger:taken", {
			bracelet: bracelet,
			machine: machine,
			reason: "fresh connection"
		});

		this.emit("braceletevents:trigger:read:battery", {
			bracelet: bracelet
		});
		return false;
	}

	return true;
}

function tryFoundResponse(device) {
	var finding = this.data;
	if (!finding.length) return;
	var bracelets = this._bracelets;
	var numBracelets = Object.keys(bracelets).reduce(function (sum, mac) {
		if (bracelets[mac]) return sum + 1;
		return sum;
	}, 0);

	if (numBracelets >= MAX_BRACELETS) return;

	finding.forEach(par(respondIfFound, device), this);
}

function respondIfFound(device, finding) {
	var bracelet = finding.bracelet;
	var machine = finding.from;

	var foundBracelet = device.id;

	if (foundBracelet !== bracelet)
		return;

	// Tell the interested party that we found their device
	this.emit("machineevents:trigger:found", {
		bracelet: bracelet,
		machine: machine,
		rssi: device.rssi
	});
}

function find(data) {
	if (IS_LEGACY) return;

	var bracelet = data.bracelet;
	var model = data.model;

	// If the bracelet mac is undefined/"" return
	if (!bracelet) return;

	if (!this.respondIfConnected(data)) return;

	// If the 'find' array is empty, add the data
	var wasFinding = !!this.data.length;

	if (!wasFinding) {
		this.setFinding([data]);
		this.emit("bluetoothscanner:trigger:start");
		return;
	}

	// Don't add if already finding this bracelet (mac & model)
	var alreadyFinding = this.data.some(function (finding) {
		return (finding.bracelet === bracelet && finding.model === model);
	});

	if (alreadyFinding) return;

	// Review to see if the new data has the same mac but different model, and if so use the new
	// data mac and model, otherwise just add the new data to the list

	var alreadyFindingMac = this.data.some(function (finding) {
		return (finding.bracelet === bracelet);
	});

	if (alreadyFindingMac) {
		var reviewed = this.data.map(function (item) {
			if (item.bracelet === bracelet) return extend(item, {
				"model": model
			});
			return item;
		});
		this.setFinding(reviewed);
	} else {
		this.setFinding(this.data.concat([data]));
	}
}

function finishFind(data) {
	if (IS_LEGACY) return;
	var existing = this.data;
	if (!existing.length) return;

	var bracelet = data.bracelet;

	var filtered = existing.filter(function (finding) {
		return finding.bracelet !== bracelet;
	});

	if (!filtered.length)
		this.emit("bluetoothscanner:trigger:stop");

	if (filtered.length === existing.length) return;

	this.setFinding(filtered);
}

function handle_take(data) {
	if (IS_LEGACY) return;

	var mac = data.bracelet;
	var model = data.model;

	if (this._bracelets[mac]) {
		this.emit("machineevents:trigger:taken", {
			machine: data.from,
			device: mac,
			reason: "already connected"
		});

		this.emit("braceletevents:trigger:read:battery", {
			bracelet: mac
		});

		return;
	}

	this.emit("bluetooth:trigger:connect", {
		mac: mac,
		model: model
	});

	this.emit("machineevents:trigger:taking", {
		device: mac,
		machine: data.from
	});
}

function handle_connection_failed(data) {
	var bracelet = data.device;
	// Must have recieved a find for this bracelet
	var owner = null;
	this.data.some(function (finding) {
		var isowner = finding.bracelet === bracelet;
		if (!isowner) return false;
		owner = finding;
		return true;
	});

	if (!owner) return;

	this.emit("machineevents:trigger:failed", {
		bracelet: bracelet,
		machine: owner.from
	});
}